import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { FeildPerformanceAnalysisReport } from './Pages';

export const FeildPerformanceAnalysisRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={FeildPerformanceAnalysisReport} />
    </Fragment>
)